const API_VERSION = 'v1';
const apiUrl = process.env.REACT_APP_API_URL;
export const apiRoot = `${apiUrl}/api/${API_VERSION}/`;

const callApi = async (endpoint, headers = {}, method = 'GET', body = null, responseType ='json') => {
  const accessToken = localStorage.getItem('token');
  const options = {
    method,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(accessToken && { Authorization: `${accessToken}` }),
      ...headers,
    },
  };

  if (body !== null) {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(apiRoot + endpoint, options);

  const newAccessToken = response.headers.get('x-access-token');
  if (newAccessToken) {
    localStorage.setItem('token', `Bearer ${newAccessToken}`);
  }

  if (!response.ok) {
    let errorData = {};
    try {
      errorData = await response.json();
    } catch { }

    const errorMessage =
      errorData?.error?.message ||
      errorData?.message ||
      'Something went wrong';

    if (
      response.status === 401 ||
      response.status === 403
    ) {
      handleSessionExpiry();
    }

    throw {
      message: errorMessage,
      status: response.status,
      data: errorData,
    };
  }

  if (response.status === 204) return null;
  if(responseType === 'blob'){
    return response.blob();
  }
  return response.json();
};

const handleSessionExpiry = () => {
  localStorage.clear();
  window.location.href = '/login';
};

export default callApi;
